"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfEditProfileDto = instanceOfEditProfileDto;
exports.EditProfileDtoFromJSON = EditProfileDtoFromJSON;
exports.EditProfileDtoFromJSONTyped = EditProfileDtoFromJSONTyped;
exports.EditProfileDtoToJSON = EditProfileDtoToJSON;
exports.EditProfileDtoToJSONTyped = EditProfileDtoToJSONTyped;
/**
 * Check if a given object implements the EditProfileDto interface.
 */
function instanceOfEditProfileDto(value) {
    return true;
}
function EditProfileDtoFromJSON(json) {
    return EditProfileDtoFromJSONTyped(json, false);
}
function EditProfileDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
    };
}
function EditProfileDtoToJSON(json) {
    return EditProfileDtoToJSONTyped(json, false);
}
function EditProfileDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'fullName': value['fullName'],
        'countryCode': value['countryCode'],
        'phoneNumber': value['phoneNumber'],
    };
}
